module.exports = __webpack_public_path__ + "img/headSculpture.9ac70d63.svg";